import { useNavigate, useParams } from "react-router-dom";
import ChatInput from "../../components/chat-input";
import MessageBubble from "../../components/message-bubble";
import NotificationCard from "../../components/notification-card";
import Layout from "./layout";
import { Box } from "@mui/material";
import { validateToken, startChat } from "../../api/chat-api";
import { useEffect, useState } from "react";
import { useToast } from "../../components/toaster";
import { TOKEN_CONSTANTS } from "../../constants/token";
import { useStateValue } from "../../context/global-context-provider";
import Loader from "../../components/loader";

const PuzzleGame = () => {
  const { token } = useParams();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [{}, dispatch] = useStateValue();
  const [tokenStatus, setTokenStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [teamName, setTeamName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      handleValidateToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (tokenStatus === TOKEN_CONSTANTS.ACTIVE) {
      handleStartChat();
    }
  }, [tokenStatus]);

  const handleStartChat = async () => {
    setLoading(true);
    try {
      const response = await startChat();

      dispatch({
        type: "SET_CHAT_DATA",
        payload: response.data.data.messages,
      });
    } catch (error) {
      if (error.response?.status === 403) {
        showToast(
          `${error.response?.data?.message || "Token validation failed"}`,
          "error"
        );
        navigate("/", { replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleValidateToken = async (token) => {
    setLoading(true);
    try {
      const response = await validateToken(token);
      setTeamName(response.data.data.team);
      setTokenStatus(response.data.status);
      setStatusMessage(response.data.message);
    } catch (error) {
      if (error.response?.status === 403) {
        showToast(
          `${error.response?.data?.message || "Token validation failed"}`,
          "error"
        );
        navigate("/", { replace: true });
      } else {
        console.error("Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const getNotificationImage = (status) => {
    if (
      status === TOKEN_CONSTANTS.EXPIRED ||
      status === TOKEN_CONSTANTS.REVOKED
    ) {
      return "/notif_illus_after.svg";
    }
    if (status === TOKEN_CONSTANTS.PENDING) {
      return "/notif_illus_before.svg";
    }
    return "/notif_illus_before.svg";
  };
  return (
    <Layout
      teamName={teamName}
      isRoute={tokenStatus === TOKEN_CONSTANTS.ACTIVE}
    >
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="80vh"
        >
          <Loader color="#D5BB4B" />
        </Box>
      ) : tokenStatus === TOKEN_CONSTANTS.ACTIVE ? (
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            height: {
              xs: "91vh",
              sm: "90vh",
            },
          }}
          justifyContent="space-between"
          alignItems="center"
        >
          <MessageBubble />
          <ChatInput />
        </Box>
      ) : tokenStatus &&
        [
          TOKEN_CONSTANTS.PENDING,
          TOKEN_CONSTANTS.EXPIRED,
          TOKEN_CONSTANTS.REVOKED,
          TOKEN_CONSTANTS.INVALID,
        ].includes(tokenStatus) ? (
        <NotificationCard
          imageSrc={getNotificationImage(tokenStatus)}
          altText="notification message"
          text={statusMessage}
        />
      ) : null}
    </Layout>
  );
};

export default PuzzleGame;
